<template>
  <base-section
    id="project"
    max-width="1024"
    class="mx-auto"
  >
    <span class="trace">sections/Project.vue top [{{ projectTitle }}] [{{ graphic }}]</span>
    <v-container>
      <base-subheading
        :title="projectTitle"
        tag="h1"
        space="12"
      />
      <!--
        title="graph"

        title="A WONDERFUL SERENITY HAS TAKEN POSSESSION"

        dummy img name random generated                                 - needs to be the same as the one that was clicked on

        :src="require(`@/assets/project-${Math.floor(Math.random() * 10)}.jpg`)"
        :src="src"

      -->
      <base-img
        :height="$vuetify.breakpoint.mdAndUp ? 499 : 250"
        :src="require(`@/assets/project-${Math.floor(Math.random() * 10)}.jpg`)"
        class="mb-6 mb-md-12"
      />

      <v-row>
        <v-col
          cols="12"
          md="8"
        >
          <base-title title="PROJECT SUMMARY_" />

          <base-body space="12">
            Lorem 2 ipsum dolor sit, amet consectetur adipisicing elit. Ut totam ipsam cum facere quam alias earum labore explicabo, corrupti molestias neque eaque assumenda adipisci nulla, nemo libero eligendi voluptatibus impedit, corrupti molestias neque eaque assumenda adipisci nulla, nemo libero eligendi voluptatibus impedit, corrupti molestias neque eaque assumenda adipisci nulla, nemo libero eligendi voluptatibus impedit!!
          </base-body>

          <v-row class="text-center">
            <v-col
              v-for="[value, title] of values"
              :key="title"
              cols="6"
              md="3"
            >
              <base-circular-progress v-bind="{ title, value }" />
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <div class="caption">
            <base-title
              title="GENERAL INFO"
              space="2"
            />

            <v-divider />

            <div class="grey--text text--darken-1">
              <template v-for="([title, sub], i) of info">
                <v-row
                  :key="title"
                  class="mx-0 my-3"
                  justify="space-between"
                >
                  <span v-text="title" />

                  <strong v-text="sub" />
                </v-row>

                <v-divider :key="`divider-${i}`" />
              </template>
            </div>
          </div>

          <div class="mt-12">
            <base-title
              align="center"
              title="SHARE"
            />

            <div class="mx-n2 text-center">
              <v-icon
                v-for="icon in icons"
                :key="icon"
                class="px-2"
                @click="() => {}"
                v-text="icon"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <span class="trace">sections/Project.vue btm</span>
  </base-section>
</template>

<script>
  export default {
    name: 'Project',

    props: {
      src: String,
      idx: Number,
      graphic: {
        type: String,
        default: 'Need graphic',
      },
      // projectTitle: String,
      projectTitle: {
        type: String,
        default: 'Need Title',
      },
      title: String,
    },

    data: () => ({
      icons: [
        'mdi-twitter',
        'mdi-facebook',
        'mdi-github',
        'mdi-snapchat',
      ],
      info: [
        ['LIVE SITE', 'ThisProject.climateActionTruro.org'],
        ['PLANNING TIME', '2 MONTHS'],
        ['EXECUTION TIME', '1 YEAR'],
        ['GOAL', '90% TOWN INVOLVEMENT'],
      ],
      values: [
        [15, 'Participatiom'],
        [75, 'Planned'],
        [10, 'Accomplished'],
        [5, 'Communicated'],
      ],
    }),

    computed: {
      testing () {
        return [
          'computedTesting',
        ]
      },
    },

  }
</script>

<style>
.more {
  color: red;
  font-style: bold;
}
</style>
